import { IconConfig } from "../types";

export const manLocked:IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 22.802 26.307",
  elements: [
    {
      type: 'g',
      transform: "translate(-34.108)",
      children: [
        {
          type: 'path',
          fill: "#d19546",
          d: "M46.973 1.085a2.4 2.4 0 0 0-1.1.263 2.84 2.84 0 0 1 .467 1.563v2.424h1.5a.55.55 0 0 1 .552.551v2.26h.707a1 1 0 0 1 .307.048V3.52a2.435 2.435 0 0 0-2.433-2.435"
        },
        {
          type: 'path',
          fill: "#b2762f",
          d: "M38.354 5.887a.55.55 0 0 1 .552-.551h7.483V2.911A2.91 2.91 0 0 0 43.477 0h-3.328a2.91 2.91 0 0 0-2.909 2.911v5.324a1 1 0 0 1 .411-.089h.707V5.887Z"
        },
        {
          type: 'path',
          d: "M38.354 5.887a.55.55 0 0 1 .217-.437V2.911A2.91 2.91 0 0 1 41.484 0h-1.335a2.91 2.91 0 0 0-2.91 2.911v5.324a1 1 0 0 1 .411-.089h.707Z",
          opacity: 0.1
        },
        {
          type: 'path',
          fill: "#ffc502",
          d: "M49.088 19.937a3.88 3.88 0 0 1 1.637-3.164h-4.03v-.579a.265.265 0 0 0-.265-.265H45.4a5.02 5.02 0 0 1-4.055 0h-1.032a.266.266 0 0 0-.265.265v.579h-4.315a1.626 1.626 0 0 0-1.625 1.623v7.64a.27.27 0 0 0 .27.27h17.987a.27.27 0 0 0 .27-.27v-2.232a3.89 3.89 0 0 1-3.547-3.867"
        },
        {
          type: 'path',
          fill: "#083e63",
          d: "M43.842 18.137h-.095l-.212.189a.25.25 0 0 1-.327 0l-.211-.189h-.095a.26.26 0 0 0-.257.257v1.253a1.21 1.21 0 0 1 1.453 0v-1.253a.26.26 0 0 0-.256-.257"
        },
        {
          type: 'path',
          fill: "#ffb98a",
          d: "M43.374 16.358a5 5 0 0 1-2.062-.443v.523a.68.68 0 0 0 .2.441l1.664 1.485a.3.3 0 0 0 .395 0l1.664-1.485a.68.68 0 0 0 .2-.441v-.521a5 5 0 0 1-2.061.441"
        },
        {
          type: 'g',
          opacity: 0.1,
          children: [
            {
              type: 'path',
              d: "M35.447 26.037v-7.64a1.626 1.626 0 0 1 1.625-1.623h-1.339a1.626 1.626 0 0 0-1.625 1.623v7.64a.27.27 0 0 0 .27.27h1.339a.27.27 0 0 1-.27-.27"
            }
          ]
        },
        {
          type: 'g',
          fill: "#ffb98a",
          children: [
            {
              type: 'path',
              d: "M49.102 8.095h-.707v3.366h.709a1.06 1.06 0 0 0 1.059-1.059v-1.25a1.06 1.06 0 0 0-1.061-1.057"
            },
            {
              type: 'path',
              d: "M38.355 11.345v-3.25h-.707a1.06 1.06 0 0 0-1.059 1.059v1.249a1.06 1.06 0 0 0 1.059 1.059h.709z"
            }
          ]
        },
        {
          type: 'g',
          fill: "#d19546",
          children: [
            {
              type: 'path',
              d: "M38.355 9.347h-.731a.386.386 0 1 0 0 .771h.731Z"
            },
            {
              type: 'path',
              d: "M49.125 9.347h-.731v.771h.731a.386.386 0 0 0 0-.771"
            }
          ]
        },
        {
          type: 'path',
          fill: "#ffd5b3",
          d: "M43.375 16.409a5.074 5.074 0 0 1-5.071-5.065V5.886a.6.6 0 0 1 .6-.6h8.935a.6.6 0 0 1 .6.6v5.454a5.074 5.074 0 0 1-5.064 5.069"
        },
        {
          type: 'g',
          opacity: 0.1,
          children: [
            {
              type: 'path',
              d: "M39.631 11.34V5.882a.6.6 0 0 1 .6-.6h-1.327a.6.6 0 0 0-.6.6v5.458a5.073 5.073 0 0 0 5.734 5.021 5.074 5.074 0 0 1-4.407-5.021"
            }
          ]
        },
        {
          type: 'g',
          fill: "#775436",
          children: [
            {
              type: 'path',
              d: "M40.922 10.282a.385.385 0 0 1-.385-.385v-.992a.386.386 0 0 1 .771 0v.992a.385.385 0 0 1-.386.385"
            },
            {
              type: 'path',
              d: "M45.827 10.282a.385.385 0 0 1-.385-.385v-.992a.386.386 0 1 1 .771 0v.992a.385.385 0 0 1-.386.385"
            }
          ]
        },
        {
          type: 'path',
          fill: "#d19546",
          d: "M43.83 11.853h-.646a.65.65 0 0 1-.65-.65V9.554a.386.386 0 0 1 .771 0v1.528h.525a.386.386 0 0 1 0 .771"
        },
        {
          type: 'g',
          fill: "#b2762f",
          children: [
            {
              type: 'path',
              d: "M39.764 8.102a.385.385 0 0 1-.272-.658 2.025 2.025 0 0 1 2.858 0 .385.385 0 0 1-.545.545 1.254 1.254 0 0 0-1.769 0 .38.38 0 0 1-.272.113"
            },
            {
              type: 'path',
              d: "M46.984 8.101a.38.38 0 0 1-.272-.113 1.253 1.253 0 0 0-1.769 0 .385.385 0 0 1-.545-.545 2.025 2.025 0 0 1 2.858 0 .385.385 0 0 1-.272.658"
            }
          ]
        },
        {
          type: 'path',
          fill: "#d19546",
          d: "M43.371 14.319a2.87 2.87 0 0 1-2.032-.84.385.385 0 0 1 .545-.545 2.107 2.107 0 0 0 2.975 0 .385.385 0 1 1 .545.545 2.87 2.87 0 0 1-2.033.84"
        },
        {
          type: 'g',
          fill: "#f7931e",
          children: [
            {
              type: 'path',
              d: "M43.757 26.306v-1.561a.386.386 0 1 0-.771 0v1.561Z"
            },
            {
              type: 'path',
              d: "M43.371 21.828a1.2 1.2 0 0 1-.385-.063v1.283a.386.386 0 1 0 .771 0v-1.286a1.2 1.2 0 0 1-.386.066"
            }
          ]
        },
        {
          type: 'path',
          fill: "#c5ccd3",
          d: "M51.682 13.022a.44.44 0 0 0-.112.271v1.286h2.675V7.127a.16.16 0 0 0-.159-.159h-1.285a.32.32 0 0 0-.244.134l-.9 1.413a.64.64 0 0 0-.085.293v.924a.44.44 0 0 0 .112.271l.463.463a.16.16 0 0 1 0 .225l-.463.463a.44.44 0 0 0-.112.271v.18a.44.44 0 0 0 .112.271l.463.463a.16.16 0 0 1 0 .225Z"
        },
        {
          type: 'path',
          d: "M51.682 13.025a.44.44 0 0 0-.112.271v1.286h1.326v-1.286a.44.44 0 0 1 .112-.271l.463-.463a.16.16 0 0 0 0-.225l-.463-.463a.44.44 0 0 1-.112-.271v-.18a.44.44 0 0 1 .112-.271l.463-.463a.16.16 0 0 0 0-.225l-.463-.463a.44.44 0 0 1-.112-.271v-.924a.64.64 0 0 1 .085-.293l.9-1.413a.33.33 0 0 1 .223-.132h-1.303a.32.32 0 0 0-.244.134l-.9 1.413a.64.64 0 0 0-.085.293v.924a.44.44 0 0 0 .112.271l.463.463a.16.16 0 0 1 0 .225l-.463.463a.44.44 0 0 0-.112.271v.18a.44.44 0 0 0 .112.271l.463.463a.16.16 0 0 1 0 .225Z",
          opacity: 0.1
        },
        {
          type: 'path',
          fill: "#9ea7af",
          d: "M52.973 16.054a3.86 3.86 0 0 1 2.04.58v-1.847a.265.265 0 0 0-.265-.265h-3.55a.265.265 0 0 0-.265.265v1.843a3.86 3.86 0 0 1 2.04-.576"
        },
        {
          type: 'path',
          d: "M52.285 16.116v-1.329a.265.265 0 0 1 .265-.265h-1.352a.266.266 0 0 0-.265.265v1.843a3.9 3.9 0 0 1 1.352-.514",
          opacity: 0.1
        },
        {
          type: 'ellipse',
          cx: 3.936,
          cy: 3.934,
          fill: "#c5ccd3",
          rx: 3.936,
          ry: 3.934,
          transform: "translate(49.037 16.003)"
        },
        {
          type: 'g',
          opacity: 0.1,
          children: [
            {
              type: 'path',
              d: "M50.381 19.94a3.935 3.935 0 0 1 3.264-3.876 3.934 3.934 0 1 0 0 7.752 3.935 3.935 0 0 1-3.264-3.876"
            }
          ]
        },
        {
          type: 'ellipse',
          cx: 1.068,
          cy: 1.067,
          fill: "#fff",
          rx: 1.068,
          ry: 1.067,
          transform: "translate(51.906 19.899)"
        },
        {
          type: 'path',
          fill: "#9ea7af",
          d: "M53.733 18.427h-1.27a.386.386 0 1 1 0-.771h1.27a.386.386 0 1 1 0 .771"
        },
        {
          type: 'ellipse',
          cx: 1.264,
          cy: 1.263,
          fill: "#046699",
          rx: 1.264,
          ry: 1.263,
          transform: "translate(42.107 19.353)"
        },
        {
          type: 'g',
          opacity: 0.1,
          children: [
            {
              type: 'path',
              d: "M43.443 20.616a1.26 1.26 0 0 1 .6-1.073 1.263 1.263 0 1 0 0 2.145 1.26 1.26 0 0 1-.6-1.072"
            }
          ]
        }
      ]
    }
  ]
}
